export enum NotificationDuration {
    NoTimeout = 0,
    Short = 3000,
    Standard = 5000,
    Long = 8000,
}
